export function pickDeps(source, keys) {
  return keys.reduce((acc, key) => {
    if (Object.prototype.hasOwnProperty.call(source || {}, key)) {
      acc[key] = source[key];
    }
    return acc;
  }, {});
}

export function defineDepKeys(keys) {
  return Object.freeze([...(keys || [])]);
}
